import React, { useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import './App.scss';

import { DownloadFilePage, LoginPage, Patients } from './pages';
import useStore from './hooks/useStore';
import { clearAuthData, isTokenExpired } from './utils/tokenHelpers';

const App = () => {
  const history = useHistory();
  const location = useLocation();

  const { scheduleStore } = useStore();

  useEffect(() => {
    const querySearchParams = new URLSearchParams(location.search);
    const login = querySearchParams.get('login');
    const password = querySearchParams.get('password');

    if (login && password) {
      return;
    }

    (async () => {
      if (isTokenExpired()) {
        history.push('/login');
        clearAuthData();
      }
    })();
  }, [history, location.search]);

  useEffect(() => {
    if (scheduleStore.unauthorizedError) {
      history.push('/login');
    }
  }, [history, scheduleStore.unauthorizedError]);

  return (
    <Switch>
      <Route exact path={'/login'} component={LoginPage} />
      <Route
        exact
        path={['/', '/studies/:studyUUID/file/:fileUUID']}
        component={Patients}
      />
      <Route
        exact
        path={'/studies/:studyUUID/files/:fileUUID'}
        component={DownloadFilePage}
      />
      <Route render={() => <div>Сторінку не знайдено</div>} />
    </Switch>
  );
};

export default observer(App);
